import { render, staticRenderFns } from "./FeatureInfoBlock.vue?vue&type=template&id=51a0e0c0"
import script from "./FeatureInfoBlock.vue?vue&type=script&lang=ts"
export * from "./FeatureInfoBlock.vue?vue&type=script&lang=ts"
import style0 from "./FeatureInfoBlock.vue?vue&type=style&index=0&id=51a0e0c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports